export const ar = {
  "Welcome to React": "أهلاً وسهلاً بك في سيرفر ريآكت",
  welcome: "أهلاً بك",
  navbar: {
    links: {
      home: "الرئيسية",
      aboutUs: "من نحن",
      services: "الخدمات",
      ourPartners: "عملائنا",
      ourTeam: "فريقنا",
      contactUs: "تواصل معنا",
      whyTotarjim: "لماذا تترجم",
    },
    useTools: {
      auth: "",
    },
  },
  // General validation messages
  validation: {
    404: "عذراً هذه الصفحة غير متوفرة",
  },

  // Translate Form
  translateForm: {
    labels: {
      language: "اللغة العربية",
      name: "الاسم",
      usefulInfo: "معلومات مفيدة !",
      email: "البريد الالكتروني",
      translateForm: "الترجمة من",
      translateTo: "الترجمة إلى",
      serviceType: "نوع الخدمة",
    },
    buttons: {
      submit: "إرسال طلب",
    },
    validation: {
      nameRequired: "الإسم مطلوب",
      emailRequired: "البريد الإلكتروني مطلوب",
      emailInvalid: "البريد الإلكتروني غير صحيح",
      languageRequired: "اللغة مطلوبة",
      fileRequired: "ملف مطلوب",
      serviceTypeRequired: "نوع الخدمة مطلوب",
    },
    selectOptions: {
      languages: {
        arabic: "العربية",
        english: "الإنجليزية",
        french: "الفرنسية",
        spanish: "الإسبانية",
        german: "الألمانية",
        italian: "الإيطالية",
        portuguese: "البرتغالية",
        russian: "الروسية",
        chinese: "الصينية",
        japanese: "اليابانية",
        korean: "الكورية",
        vietnamese: "الفيتنامية",
        thai: "التايلاندية",
        indonesian: "الأندونيسية",
        bengali: "البنغالية",
        malay: "المالية",
        tagalog: "التاغالو",
        telugu: "التيلوغو",
        tamil: "التاميلية",
        urdu: "الأردية",
        marathi: "المراتيشية",
        bhojpuri: "البوجبيرية",
        punjabi: "البنجابية",
        gujarati: "الغوجاراتية",
        kannada: "الكننادية",
        malayalam: "المالايالامية",
        oriya: "الأوريا",
        panjabi: "البنجابية",
      },
      services: {
        0: "بحث التخرج",
        1: "ورقة ابحاث",
        2: "ترجمة قانونية",
        3: "بحث علمي",
        4: "كتابة محتوى",
        5: "تعليق صوتي",
        6: "تدوين",
      },
    },
    placeholders: {
      name: "أدخل الاسم",
      email: "أدخل البريد الإلكتروني",
      serviceType: "نوع الخدمة",
      translateForm: "الترجمة من",
      translateTo: "الترجمة إلى",
    },
  },
  sections: {
    header: {
      title: "شريكك في الترجمة الجدير بالثقة",
      subtitle: "ترجم نصك من لغة إلى أخرى",
      text: "نحن فريق من المترجمين والمصممين ذوي الخبرة. نحن هنا لمساعدتك في ترجمة نصك من لغة إلى أخرى.",
      button: "الخدمات",
      form: {
        success: "تم إرسال رسالتك بنجاح",
        error: "حصل خطأ ما !",
        loading: "جاري إرسال الرسالة",
      },
    },
    aboutUs: {
      title: "عن تُترجم",
      text: `نستفيد في ترجمة من تقنياتنا المقتدمة التي نمتلكها لتمكين كوادرنا من تقديم محتوى يتلاءم مع احتياجات أعمالكم بسرعة وفعالية كبيرة. تعتمد ترجمة نموذج أعمال قائم على إحداث تغيير جذري في أسلوب عمل قطاع الخدمات اللغوية من خلال دمج تقنيات الذكاء الاصطناعي في جميع خطوات عملنا.`,
      link: "إقرأ المزيد",
    },
    services: {
      title: "الخدمات",
      text: `
      يقدم “تُترجم” نطاًقا واسًعا من الخدمات اللغوية التي تمكن العملاء من التواصل بطريقة أفضل مع الجهات المعنية بأعمالهم, وذلك بتوفير محتوى دقيق وقّيم وغني بالمعلومات.
      `,
      link: "رؤية المزيد",
      servicesDetails: {
        consulting: {
          title: "خدمات استشارية",
          text: `يضمّ فريق عملنا خبراءَ استراتيجيين من مختلف القطاعات والمجالات, وهم على أتمّ الاستعداد لتقديم المشورة للعملاء بشأن إحداث التأثير وتوفير الفرص للطاقات والكفاءات غير المستغلة.`,
        },
        employment: {
          title: "التوظيف وبناء القدرات",
          text: `
          نوظف خبرتنا التي تمتد لأكثر من عقد في هذا المجال لدعم عملائنا من خلال موظفين محترفين وذلك لتقديم أقصى قيمة ممكنة والحد قدر الإمكان من الاستعانة بكوادر خارجية لإنجاز المهام المطلوبة.
          `,
        },
        training: {
          title: "التدريب والتطوير المهني",
          text: `
          بفضل خبراتهم العملية التي اكتسبوها على مدار سنوات طويلة, سيتمكن خبراؤنا من تقديم وإعداد دورات تدريبية متخصصة تلبي احتياجات الشركات والمؤسسات.
          `,
        },
        vision: {
          title: "توفير الرؤى المتقدمة",
          text: `
          نستخدم أحدث الأدوات والأساليب وأكثرها تطوًرا لجمع البيانات وتنظيمها وتحليلها من أجل تزويد عملائنا بخدمات المقارنات المرجعية والتنبؤية بأعلى مستوى من الدقة.

          `,
        },
      },
    },
    ourTeam: {
      title: "فريقنا",
      text: `
      العمل الجماعي هو القدرة على العمل معًا نحو رؤية مشتركة. القدرة على توجيه الإنجازات الفردية لتحقيق الأهداف التنظيمية. إنه الوقود الذي يسمح لعامة الناس بتحقيق نتائج غير مألوفة.
      `,
      members: {
        0: {
          name: "أحمد صيام",
          position: "شريك مؤسس",
        },
        1: {
          name: "محمد الزينة",
          position: "شريك مؤسس",
        },
        2: {
          name: "ميس الحسني",
          position: "مترجم",
        },
        3: {
          name: "سارة طرمان",
          position: "مترجم",
        },
      },
    },
    ourPartners: {
      title: "شركائنا",
      text: `
      سعدنا بالعمل مع
      `,
    },
    footer: {
      address: "فلسطين، قطاع غزة، محافظة غزة",
      phone: "054-567-890",
      contactTitle: "اتصل بنا",
      contactText: `شركة متخصصة بتقديم خدمات الترجمة.
      ترجمة الوثائق بموضوعاتها المختلفة من العربية إلى الإنجليزية والعكس.
      التفريغ الصوتي والمرئي.`,
      pages: {
        title: "الصفحات",
        home: "الرئيسية",
        about: "من نحن",
        services: "الخدمات",
        ourTeam: "فريقنا",
        ourPartners: "شركائنا",
        contact: "اتصل بنا",
      },
      services: {
        title: "الخدمات",
        0: "بحث التخرج",
        1: "ورقة ابحاث",
        2: "ترجمة قانونية",
        3: "بحث علمي",
        4: "كتابة محتوى",
        5: "تعليق صوتي",
        6: "تدوين",
      },
    },
  },
  pages: {
    auth: {
      login: "الدخول",
      register: "حساب جديد",
      loginWithFacebook: "تسجيل باستخدام فيسبوك",
      loginWithGoogle: "تسجيل باستخدام جوجل",
      loginWithTwitter: "تسجيل باستخدام تويتر",
      registerToNameText: "تسجيل جديد إلى تُترجم",
      loginToNameText: "تسجيل الدخول إلى تُترجم",
      dontHaveAccount: "ليس لديك حساب؟",
      alreadyHaveAccount: "هل لديك حساب؟",
      createNewAccount: "إنشاء حساب جديد",
      haveAccount: "لديك حساب؟",
      loginNow: "تسجيل الدخول",
      welcomeBack: "مرحبا بعودتك",
      client: "عميل",
      translator: "مترجم",
      fullName: "الاسم الكامل",
      phoneNumber: "رقم الهاتف",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      confirmPassword: "تأكيد كلمة المرور",
      rememberMe: "تذكرني",
      forgotPassword: "نسيت كلمة المرور",
      country: "الدولة",
      registerNow: "تسجيل الآن",
      emailOrPhoneNumber: "البريد الالكتروني او رقم الهاتف",
      requestPasswordChange: "طلب تغيير كلمة المرور",
      needHelp: "هل انت بحاجة لمساعدة؟",
      customerSupport: "دعم العملاء",
      checkPhone: "تحقق من هاتفك",

      useCases: {
        title: "إختر الحالات المستخدمة",
        note: "ملاحظة: فقط يمكنك إختيار حالتين",
        cases: {
          0: "ترجمة قانونية",
          1: "ترجمة تقنية",
          2: "ترجمة مالية",
          3: "الترجمة التسويقية",
          4: "ترجمة المواقع",
          5: "ترجمة الوثائق",
        },
      },
    },
  },
};
